<template>
  <page-layout>
    <el-card>
      <div slot="header">
        <span>网点信息管理</span>
      </div>
      <p>网点信息管理页面内容</p>
    </el-card>
  </page-layout>
</template>

<script>
export default {
  name: 'NetworkPointList'
}
</script>



